module.exports = new __parcel__URL__("self-tour-house.dc564226.svg").toString();